// extracted by mini-css-extract-plugin
export default {"Modal":"Modal_Modal__LPXJr","pop-in":"Modal_pop-in__cQPvH","Exit":"Modal_Exit__Z2Ncn","pop-out":"Modal_pop-out__+eUft","Button":"Modal_Button__T0mqW","Item":"Modal_Item__0aYUf"};